export default {"src":"/_next/static/media/fb.e8bc8043.svg","height":49,"width":48,"blurWidth":0,"blurHeight":0};